import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=2afa921e&scoped=true&"
import script from "./MemberList.vue?vue&type=script&lang=js&"
export * from "./MemberList.vue?vue&type=script&lang=js&"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=2afa921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa921e",
  null
  
)

export default component.exports